var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakingEntriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 55,
    viewBox: "0 0 42 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.484131 7.69788C8.49544 7.69788 13.31 7.39664 20.9909 0.953613C28.6718 7.39664 33.4863 7.69788 41.4977 7.69788V33.6296C41.4977 42.5217 36.1086 45.7664 26.211 51.7257C24.5906 52.7014 22.8492 53.7499 20.9909 54.9078C19.1326 53.7499 17.3912 52.7014 15.7707 51.7257C5.87316 45.7664 0.484131 42.5217 0.484131 33.6296V7.69788ZM24.0604 23.7627L20.991 14.4423L17.9216 23.7627H7.98895L16.0247 29.523L12.9553 38.8433L20.991 33.083L29.0267 38.8433L25.9574 29.523L33.9931 23.7627H24.0604Z",
    fill: "#FCD559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingEntriesIcon);
export default __webpack_public_path__ + "static/media/staking-entries-icon.0655c64eb4c2ed1d227e77ba1cf55cd8.svg";
export { ForwardRef as ReactComponent };